import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import styles from "./MainMenuDropdown.scss";

const cx = classnames.bind(styles);

const MainMenuDropdown = ({ children, isMobile, footer, classNames }) => (
  <div className={cx("main-menu-dropdown", { "is-mobile": isMobile }, classNames)}>
    <div className={cx("content")}>
      {children}
      {isMobile && footer}
    </div>
    {!isMobile && footer}
  </div>
);

MainMenuDropdown.propTypes = {
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  footer: PropTypes.node,
  classNames: PropTypes.string,
};

export default MainMenuDropdown;
